import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';

const styles = () => ({
	pickerCardPaper : {
		height : '100%',
		textAlign : 'left',
	},
	pickerCardPadding : {
		padding : 20,
	},
	pickCardTitleContainer : {
		paddingTop : 0,
		display : 'flex',
		alignContent : 'center',
		alignItems: 'center',
		paddingBottom : 20,
	},
	pickerCardTitle : {
		paddingLeft : 20,
		fontSize : 28,
		color : '#555',
		fontWeight : 300,
	},
	icon : {
		width : 115,
		margin: -15,
	},
	pickerCardDescriptionLabel : {
		textTransform : 'uppercase',
		color : '#999',
		fontSize : 16,
	},
	pickerCardDescription : {
		fontSize : 18,
	},
	pickerCardButtonContainer : {
		textAlign : 'right',
		paddingTop : 30,
	},
	pickerCardButton : {
		paddingRight : 50,
		paddingLeft : 50,
		//fontSize : 18,
	},
	welcome : {
		fontSize: 50,
		color: '#666',
		letterSpacing: 1,
		textTransform: 'uppercase',
		fontWeight: 300,
		marginBottom: 10,
		//margin: '2px 0px 5px 0px',
		position: 'relative',
		marginLeft: 0,
	},
});


class FMPSectionCard extends Component {

	render() {
		const {
			classes,
			title,
			description,
			url,
			icon,
			disabled
		} = this.props;

		return (
			<Paper className={classes.pickerCardPaper}>
				<div className={classes.pickerCardPadding}>
					<div className={classes.pickCardTitleContainer}>
						<img
							alt="Action Icon"
							src={icon}
							className={classes.icon}
						/>
						<span className={classes.pickerCardTitle}>{title}</span>
					</div>
					<div>
						<div className={classes.pickerCardDescription}>
							{description}
						</div>

						<div className={classes.pickerCardButtonContainer}>
							<Link to={url} style={{textDecoration: 'none'}}>
								<Button
									variant="contained"
									color="primary"
									aria-label="Add"
									className={classes.pickerCardButton}
									disabled={disabled}
								>
									Go
								</Button>
							</Link>
						</div>
					</div>
				</div>
			</Paper>
		);
	}
}

FMPSectionCard.propTypes = {
	classes: PropTypes.object.isRequired,
	title: PropTypes.string,
	description: PropTypes.string,
	url: PropTypes.string,
	icon: PropTypes.node,
	disabled: PropTypes.bool
};

export default _.flow([
	withStyles(styles),
])(FMPSectionCard);
